function PCVideoutil() {
    Date.prototype.formatNowTime = function(_time) { //格式化时间
        var o = {
            "M+": this.getMonth() + 1, //月份 
            "d+": this.getDate(), //日 
            "h+": this.getHours(), //小时 
            "m+": this.getMinutes(), //分 
            "s+": this.getSeconds(), //秒 
            "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
            "S": this.getMilliseconds() //毫秒 
        };
        if (/(y+)/.test(_time)) _time = _time.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(_time)) _time = _time.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return _time;
    };
}
PCVideoutil.prototype = {
    showTextMenu: function(e) { //自定义右键菜单样式
        var clickX = e.clientX,
            clickY = e.clientY;
        var videoMenu = document.getElementById('js_video_menu');
        videoMenu.style.display = 'block';
        videoMenu.style.left = clickX - videoboxLeft + 'px';
        videoMenu.style.top = clickY - getEleOffsetTop(box) + 'px';
        e.stopPropagation();
        e.preventDefault();
    },
    hideTextMenu: function() { //隐藏右键后的自定义菜单
        var videoMenu = document.getElementById('js_video_menu');
        videoMenu.style.display = 'none';
    },
    hasClass: function(ele, classname) { //检测某个元素是否含有该类名
        return ele.className.indexOf(classname);
    },
    removeClass: function(ele, classname) { //移除类名
        if (this.hasClass(ele, classname) > -1) {
            var reg = new RegExp('(\\s|^)' + classname + '(\\s|$)');
            ele.className = ele.className.replace(reg, ' ');
        }
    },
    addClass: function(ele, classname) { //添加类名
        if (this.hasClass(ele, classname) < 0) {
            ele.className += ' ' + classname;
        }
    },
    getStyle: function(ele) { //获取元素现在的sytle
        var cur = ele.currentStyle ? ele.currentStyle : document.defaultView.getComputedStyle(ele, null);
        return cur;
    },
    delNodes: function(ele) { //获取后代，删除无用node
        var ele_child = ele.childNodes;
        for (var i = 0; i < ele_child.length; i++) {
            if (ele_child[i].nodeName == "#text" && !/\s/.test(ele_child.nodeValue)) {
                ele.removeChild(ele_child[i]);
            }
        }
        return ele;
    },
    removeElement: function() { //删除元素
        for (var i = 0, ilen = arguments.length; i < ilen; i++) {
            var _parentElement = arguments[i].parentNode;
            if (_parentElement) _parentElement.removeChild(arguments[i]);
        }
    },
    moretime: function(time) {

        var seconds = Math.round((time % 60)) < 10 ? '0' + Math.round((time % 60)) : Math.round((time % 60));
        var minutes = parseInt(time / 60 % 60) < 10 ? '0' + parseInt(time / 60 % 60) : parseInt(time / 60 % 60);
        var hours = parseInt(time / 3600 % 24);
        var goodhours = hours < 10 ? '0' + hours : hours;
        if (hours == 0) {
            return minutes + ':' + seconds;
        } else {
            return goodhours + ':' + minutes + ':' + seconds;
        }
    },
    formatTime: function(_time) { //格式化时间
        var second = _time / 1,
            temp = [],
            s;

        if (second === 0) {
            return '00:00';
        }
        while (second !== 0) {
            s = second % 60;
            if (s < 10) {
                s = '0' + s;
            }
            temp.unshift(s);
            second = Math.floor(second / 60);
        }
        if (temp.length < 2) {
            temp.unshift('00');
        }
        return temp.join(':');
    },
    formatNum: function(num) { //格式化数字
        var _num = num < 100 ? (num < 10 ? '00' + num : '0' + num) : num;
        return _num;
    },
    getEleOffsetLeft: function(obj) { //获取元素相对于浏览器窗口最左边的距离
        var l = obj.offsetLeft;
        while (obj.offsetParent != null) {
            obj = obj.offsetParent;
            l += obj.offsetLeft;
        }
        return l;
    },
    getEleOffsetTop: function(obj) { //获取元素相对于浏览器窗口最顶部的距离
        var l = obj.offsetTop;
        while (obj.offsetParent != null) {
            obj = obj.offsetParent;
            l += obj.offsetTop;
        }
        return l;
    },
    bind: function(ele, type, fn) { //给元素绑定相应事件
        if (typeof(type) == 'string') {
            ele.addEventListener ? ele.addEventListener(type, fn, false) : ele.attachEvent ? ele.attachEvent('on' + type, fn) : el['on' + type] = fn;
        } else {
            for (var i in type) {
                ele.addEventListener ? ele.addEventListener(type[i], fn, false) : ele.attachEvent ? ele.attachEvent('on' + type[i], fn) : ele['on' + type[i]] = fn;
            }
        }
    },
    removeHandler: function(element, type, handler) {
        if (element.removeEventListener) {
            element.removeEventListener(type, handler, false);
        } else if (element.detachEvent) {
            element.detachEvent("on" + type, handler);
        } else { element["on" + type] = null; }
    },
    extend: function() {
        var result = {};
        for (var i = 0, iLen = arguments.length; i < iLen; i++) {
            var o = arguments[i];
            for (var key in o) {
                result[key] = o[key];
            }
        }
        return result;
    },
    playerSetCookie: function(name, value, path, domain, expires, secure) { //设置cookie
        var doFn = encodeURIComponent;
        var cStrArr = [];
        cStrArr.push(name + '=' + doFn(value));
        if (expires) {
            var date = new Date();
            date.setTime(date.getTime() + (expires) * 1000 * 60);
            cStrArr.push('; expires=' + date.toGMTString());
        }
        cStrArr.push((path) ? '; path=' + path : '');
        cStrArr.push((domain) ? '; domain=' + domain : '');
        cStrArr.push((secure) ? '; secure' : '');
        document.cookie = cStrArr.join('');
    },
    playerGetAll: function() {
        var cookieArr = [];
        if (document.cookie !== '') {
            var cStrArr = document.cookie.split(';');
            for (var i = 0, l = cStrArr.length; i < l; i++) {
                var cStr = cStrArr[i];
                var index = cStr.indexOf('=');
                var name = cStr.substring(0, index).replace(/[ ]/g, "");
                var value = cStr.substring(index + 1);
                var cookie = {};
                cookie.name = name;
                cookie.value = value;
                cookieArr.push(cookie);
            }
        }
        return cookieArr;
    },
    playerGetCookie: function(name) { //获取cookie
        var cookieArr = this.playerGetAll();
        for (var i = 0, l = cookieArr.length; i < l; i++) {
            var cookie = cookieArr[i];
            if (cookie.name === name) {
                var doFn = decodeURIComponent;
                return doFn(cookie.value);
            }
        }
        return '';
    },
    showFlashPlayer: function() { //显示flash播放器，隐藏video播放器，用于两者间的转换
        document.getElementById('playercontainer').style.display = 'none';
        document.getElementById('vPlayer_box').style.display = 'block';
        document.getElementById('playercontainer').parentNode.removeChild(document.getElementById('playercontainer'));
    },
    ifIE: function() { //判断是否为ie浏览器
        var ieFlag = !!window.ActiveXObject || "ActiveXObject" in window ? true : false;
        return ieFlag;
    },
    ifFlash: function() { //判断是否为flash播放器，用于flash和video的切换
        var flashFlag = this.playerGetCookie('ifFlag');
        return false;
    },
    getOS: function() {
        var sUserAgent = navigator.userAgent,
            _platform = navigator.platform,
            isWin = (_platform == 'Win32') || (_platform == 'Windows'),
            isMac = (_platform == 'Mac68K') || (_platform == 'MacPPC') || (_platform == 'Macintosh') || (_platform == 'MacIntel');
        if (isMac) return 'Mac';
        var isUnix = (_platform == 'X11') && !isWin && !isMac;
        if (isUnix) return 'Unix';
        var isLinux = (String(_platform).indexOf('Linux') > -1);
        if (isLinux) return 'Linux';
        if (isWin) {
            var isWin2K = sUserAgent.indexOf('Windows') > -1 || sUserAgent.indexOf('Windows 2000') > -1;
            if (isWin2K) return "Win2000";
            var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
            if (isWinXP) return "WinXP";
            var isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
            if (isWin2003) return "Win2003";
            var isWinVista = sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
            if (isWinVista) return "WinVista";
            var isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
            if (isWin7) return "Win7";
        }
        return "other";
    },
    getBrowser: function() {
        var explorer = window.navigator.userAgent.toLowerCase();
        if (explorer.indexOf("msie") >= 0) { //ie
            var ver = explorer.match(/msie ([\d.]+)/)[1];
            return {
                type: "IE",
                version: ver
            };
        } else if (explorer.indexOf("firefox") >= 0) { //firefox
            var ver = explorer.match(/firefox\/([\d.]+)/)[1];
            return {
                type: "Firefox",
                version: ver
            };
        } else if (explorer.indexOf("chrome") >= 0) { //chrome
            var ver = explorer.match(/chrome\/([\d.]+)/)[1];
            return {
                type: "Chrome",
                version: ver
            };
        } else if (explorer.indexOf("opera") >= 0) { //opera
            var ver = explorer.match(/opera.([\d.]+)/)[1];
            return {
                type: "Opera",
                version: ver
            };
        } else if (explorer.indexOf("safari") >= 0) { //safari
            var ver = explorer.match(/version\/([\d.]+)/)[1];
            return {
                type: "Safari",
                version: ver
            };
        } else {
            return {
                type: "",
                version: ver
            };
        }
    },
    getResolution: function() {
        return {
            screenW: screen.width,
            screenH: screen.height
        }
    },
    getCookie: function(name) {
        var cStrArr = document.cookie.split(';');
        for (var i = 0, l = cStrArr.length; i < l; i++) {
            var cStr = cStrArr[i];
            var index = cStr.indexOf('=');
            var cname = cStr.substring(0, index).replace(/[ ]/g, "");
            var value = cStr.substring(index + 1);
            if (cname === name) {
                return decodeURIComponent(value);
            }
        }
        return '';
    },

    setCookie: function(name, value) {
        var cStrArr = [];

        cStrArr.push(name + '=' + encodeURIComponent(value));
        var date = new Date();
        date.setTime(date.getTime() + 24 * 60 * 1000 * 60 * 7);
        cStrArr.push('; expires=' + date.toGMTString());
        cStrArr.push('; path=/');
        cStrArr.push('; domain=.ifeng.com');

        document.cookie = cStrArr.join('');
    },
    getRandomUid: function() {
        var date = new Date().getTime(),
            uid = '',
            fn = '',
            sn = '';

        fn = ((Math.random() * 2147483648) | 0).toString(36);
        sn = Math.round(Math.random() * 10000);
        uid = date + '_' + fn + sn;
        return uid;
    },
    getCurrentViedoInfo: function() {
        var result = videoinfo;
        var o = {};
        o.img = encodeURIComponent(result.videoLargePoster);
        o.title = encodeURIComponent(result.name);
        o.url = encodeURIComponent(result.url);
        o.guid = result.guid;
        return o;
    },
    shareVideo: function(sTag, type) {
        var info = this.getCurrentViedoInfo();
        var _tp = new Date().getTime();
        var url;
        var appkey;
        var site;

        switch (sTag) {
            case "sinateew":

                // 这个请求是405。。
                // ifeng.util.getScript('http://api.t.sina.com.cn/friendships/create/1806128454.xml?source=168486312');
                url = "http://v.t.sina.com.cn/share/share.php?" +
                    "appkey=168486312&url=" + info.url + encodeURIComponent("?tp=" + _tp + "#_share=sina") +
                    "&title=" + info.title +
                    "&source=ifeng&sourceUrl=http://v.ifeng.com/&content=utf8&ralateUid=1806128454" +
                    "&pic=" + info.img;

                window.open(url,
                    "",
                    "toolbar=0,status=0,resizable=1,width=440,height=430" +
                    ",left=" + (screen.width - 440) / 2 +
                    ",top=" + (screen.height - 430) / 2);
                break;

            case "qqzone":
                window.open("http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" + info.url + encodeURIComponent("?tp=" + _tp + "#_share=qqZone"));
                break;

            case "qqteew":
                appkey = encodeURIComponent("f8ca1cd768da4529ab190fae9f1bf21d");
                site = "http://v.ifeng.com";
                //http://connect.qq.com/widget/shareqq/index.html?title=&url=&desc=&pics=&site=&callback=?userId=0
                //http://connect.qq.com/intro/sharetoqq/index.html?title='实拍台军拒统利器宣传片 毫不避讳台独姿态'&url=http://v.ifeng.com/test/wx_test.shtml&desc=按发送方师傅上发生地方&pics=&site=ddd
                url = "http://connect.qq.com/widget/shareqq/index.html?title=" +
                    info.title + "&url=" + info.url + encodeURIComponent("?tp=" + _tp + "#_share=qq") + "&appkey=" + appkey +
                    "&site=" + site + "&pic=" + info.img;
                window.open(url);
                break;
            case "renren":
                url = "http://share.renren.com/share/buttonshare.do?" +
                    "link=" + info.url + encodeURIComponent("?tp=" + _tp + "#_share=" + type) +
                    "&title=" + info.title;
                window.open(url);
                break;

            case "ifengteew":
                url = "http://t.ifeng.com/interface.php?_c=share&_a=share" +
                    "&sourceUrl=" + info.url + encodeURIComponent("?tp=" + _tp + "#_share=" + type) +
                    "&title=" + info.title +
                    "&pic=" + info.img +
                    "&source=" + encodeURIComponent("凤凰视频") +
                    "&type=1";
                window.open(url,
                    "",
                    "toolbar=0,status=0,resizable=1,width=640,height=481" +
                    ",left=" + (screen.width - 440) / 2 +
                    ",top=" + (screen.height - 480) / 2);

                break;

            case "kaixin":
                url = "http://www.kaixin001.com/repaste/share.php?" +
                    "rurl=" + info.url + encodeURIComponent("?tp=" + _tp + "#_share=" + type) +
                    "&rtitle=" + info.title;
                window.open(url);
                break;

            case "sohuteew":
                url = "http://t.sohu.com/third/post.jsp?" +
                    "url=" + info.url + encodeURIComponent("?tp=" + _tp + "#_share=" + type) +
                    "&title=" + info.title +
                    "&content=utf-8" +
                    "&pic=" + info.img;
                window.open(url,
                    "",
                    "toolbar=0,status=0,resizable=1,width=660,height=470" +
                    ",left=" + (screen.width - 660) / 2 +
                    ",top=" + (screen.height - 470) / 2);
                break;

            case "163":
                url = "http://t.163.com/article/user/checkLogin.do?" +
                    "link=http://www.ifeng.com" +
                    "&source=" + encodeURIComponent("凤凰网") +
                    "&info=" + info.title + info.url + encodeURIComponent("?tp=" + _tp + "#_share=" + type) +
                    "&" + new Date().getTime();
                window.open(url,
                    "",
                    "height=330,width=550,toolbar=no,menubar=no,scrollbars=no,resizable=yes,location=no,status=no" +
                    ",top=" + (screen.height - 280) / 2 +
                    ",left=" + (screen.width - 550) / 2);
                break;

            case "feixin":
                url = "http://space.fetion.com.cn/api/share?" +
                    "Source=" + encodeURIComponent("凤凰视频") +
                    "&Title=" + info.title +
                    "&url=" + info.url + encodeURIComponent("?tp=" + _tp + "#_share=" + type) +
                    "&IsEditTitle=false";
                window.open(url);
                break;

                // 对网址有验证，所以内网地址通不过
            case "51com":
                url = "http://share.51.com/share/out_share_video.php?" +
                    "from=" + encodeURIComponent("凤凰视频") +
                    "&title=" + info.title +
                    "&vaddr=" + info.url + encodeURIComponent("?tp=" + _tp + "#_share=" + type) +
                    "&IsEditTitle=false&charset=utf-8";
                window.open(url);
                break;

                // 对网址有验证，所以内网地址通不过
            case "baiduI":
                url = "http://tieba.baidu.com/i/app/open_share_api?" +
                    "link=" + info.url + encodeURIComponent("?tp=" + _tp + "#_share=" + type);
                window.open(url);
                break;

            case "weixin":
                url = "http://v.ifeng.com/weixin.shtml?title=" + info.title + "&link=" + info.url;
                window.open(url,
                    "分享到微信",
                    "height=984,width=850,toolbar=no,menubar=no,scrollbars=no,resizable=yes,location=no,status=no" +
                    ",top=" + (screen.height - 280) / 2 +
                    ",left=" + (screen.width - 550) / 2);
                break;

            default:

                break;
        }
    },
    sendStatisticInfoC: function(type) {
        var statistic = {};
        statistic.datatype = 'share';
        statistic.value = type;


        var userid;

        if (this.getCookie('userid') === '') {
            userid = this.getRandomUid();
            this.setCookie('userid', userid);
        } else {
            userid = this.getCookie('userid');
        }

        // var doms = F.query('script');
        statistic.ref = window.location.host;

        var sid = this.getCookie('sid');
        statistic.sid = sid;

        if (typeof videoinfo != 'undefined') {
            var categoryPath = videoinfo.categoryPath;
            if (categoryPath) {
                var info = "http://v.ifeng.com/" + categoryPath + "/,,,";
            } else {
                var info = "http://v.ifeng.com/,,,";
            }
        }
        statistic.ci = info;
        statistic.pt = 'vtype=player';
        statistic.time = new Date().getTime();;
        statistic.uri = window.location.href;


        this.sendStatisticInfoM(statistic);
        return statistic;
    },
    sendStatisticInfoM: function(param) {
        var statisticUrl = "http://stadig.ifeng.com/actsta.js";
        $.ajax({
            url: statisticUrl,
            data: param,
            cache: true,
            dataType: 'script'
        });
    }

};

module.exports = PCVideoutil;



// WEBPACK FOOTER //
// ./components/f.core.util.pc/index.js